import React from 'react'
import * as UI from 'ui'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import RedirectOnPipe from 'support/pipelines/pipes/RedirectOnPipe'
import { CanUseModel } from '@morningtrain/react-auth'

export default function ImpersonateActions ({ id }) {
  return (
    <>
      <CanUseModel permission='app.users.impersonation'>
        <Pipeline>
          <TriggerPipelineOnClick>
            <UI.Button>
              Impersonate
            </UI.Button>
          </TriggerPipelineOnClick>
          <RedirectOnPipe routeName='app.users.impersonation' parameters={{ user: id }} />
        </Pipeline>
      </CanUseModel>
      <CanUseModel permission='app.users.impersonation_tablet'>
        <Pipeline>
          <TriggerPipelineOnClick>
            <UI.Button>
              Impersonate tablet
            </UI.Button>
          </TriggerPipelineOnClick>
          <RedirectOnPipe routeName='app.users.impersonation_tablet' parameters={{ user: id }} />
        </Pipeline>
      </CanUseModel>
    </>
  )
}
